import type { SwarmEvent } from '../types.js';

const KIND_LABEL: Record<SwarmEvent['kind'], string> = {
  coordinator_plan: 'coordinator',
  lane_assign: 'assign',
  lane_progress: 'progress',
  lane_done: 'done',
  lane_handoff: 'handoff',
  approval_request: 'approval',
  approval_resolve: 'approval',
  voice_dispatch: 'voice',
};

function formatTime(ts: number): string {
  return new Date(ts).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
}

export function SwarmFeed({ events }: { events: SwarmEvent[] }) {
  return (
    <section className="panel swarm-feed" aria-label="Swarm event feed">
      <div className="section-heading">
        <span className="section-kicker">Swarm feed</span>
        <strong>Visible inter-agent activity</strong>
      </div>

      <ol className="swarm-feed-list">
        {events.length === 0 ? (
          <li className="swarm-feed-empty">No events yet. Give the coordinator a goal.</li>
        ) : (
          events.slice(0, 30).map((event) => (
            <li key={event.id} className={`swarm-feed-item swarm-feed-${event.kind}`}>
              <span className="swarm-feed-time">{formatTime(event.at)}</span>
              <span className="swarm-feed-kind">{KIND_LABEL[event.kind]}</span>
              <span className="swarm-feed-summary">{event.summary}</span>
            </li>
          ))
        )}
      </ol>
    </section>
  );
}
